import { render, staticRenderFns } from "./addinspectiontour.vue?vue&type=template&id=305e6ba6&scoped=true&"
import script from "./addinspectiontour.vue?vue&type=script&lang=js&"
export * from "./addinspectiontour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305e6ba6",
  null
  
)

export default component.exports